import { formatShortDuration } from "../../common/common_funcs.js";
import { TournamentService } from "../../tournament/tournament_service.js";
import { ImgID } from "../../image_loader/img_id.js";
import { UINineSliceElement } from "../common_ui_elements/ui_nine_slice_element.js";
import { MyTextAlign, MyTextVerticalAlign, UITextElement } from "../common_ui_elements/ui_text_element.js";
import { ColorScheme } from "../common_ui_elements/color_scheme.js";
import { TextStyleScheme } from "../common_ui_elements/text_style_scheme.js";
import { AbstractTournamentDialog } from "./abstract_tournament_dialog.js";
import { DialogManager } from "./dialog_manager.js";

export class TournamentWaitDialog extends AbstractTournamentDialog
{
  private static readonly BG_H = 1043;
  private static readonly STARTS_IN_W = 819;
  private static readonly STARTS_IN_H = 166;
  private static readonly STARTS_IN_Y = 572;
  private static readonly GREEN_BTN_W = 520;
  private static readonly GREEN_BTN_H = 255;
  private static readonly GREEN_BTN_Y = 738;

  private starts_in_text!: UITextElement;

  constructor()
  {
    super( LayoutScaler.heightFromDesign( TournamentWaitDialog.BG_H ) );

    this.createStartsInText();
    this.createGreenButton();
  }

  public static open(): TournamentWaitDialog
  {
    return DialogManager.openPooled( "TournamentWaitDialog", undefined, () => new TournamentWaitDialog() ) as TournamentWaitDialog;
  }

  public override isPoolable(): boolean { return true; }

  public override onReuse(): void
  {
    this.starts_in_text.setTextVariableParams( [ formatShortDuration( TournamentService.getMsUntilStart() ).replace( / /g, " " ) ] );
  }

  public name(): string { return "TournamentWaitDialog"; }

  private createStartsInText(): void
  {
    this.starts_in_text = new UITextElement(
      this.ctx,
      this.bgCenterX( TournamentWaitDialog.STARTS_IN_W ),
      this.bgY( TournamentWaitDialog.STARTS_IN_Y ),
      LayoutScaler.widthFromDesign( TournamentWaitDialog.STARTS_IN_W ),
      LayoutScaler.heightFromDesign( TournamentWaitDialog.STARTS_IN_H ),
      {
        localization_key: "TOURNAMENT.STARTS_IN",
        text_variable_params: [ formatShortDuration( TournamentService.getMsUntilStart() ).replace( / /g, " " ) ],
        font_size: LayoutScaler.textSizeFromDesign( 70 ),
        min_font_size: LayoutScaler.textSizeFromDesign( 44 ),
        font_weight: 900,
        text_color: ColorScheme.white,
        text_style: TextStyleScheme.geologica,
        text_align: MyTextAlign.Center,
        vertical_align: MyTextVerticalAlign.Center,
        auto_wrap: true,
        fit_font_size: true,
        line_height: 0.95,
        outline_width: LayoutScaler.textBorderSizeFromDesign( 10 ),
        outline_color: ColorScheme.tournament_text_outline,
      }
    );
    this.addChild( this.starts_in_text );
  }

  private createGreenButton(): void
  {
    const btn_w = LayoutScaler.widthFromDesign( TournamentWaitDialog.GREEN_BTN_W );
    const btn_h = LayoutScaler.heightFromDesign( TournamentWaitDialog.GREEN_BTN_H );

    const button = new UINineSliceElement(
      this.ctx,
      this.bgCenterX( TournamentWaitDialog.GREEN_BTN_W ),
      this.bgY( TournamentWaitDialog.GREEN_BTN_Y ),
      btn_w,
      btn_h,
      ImgID.UI_GreenFrameBtn,
      "frame_btn",
      undefined,
      undefined,
      true
    );

    button.addChild( new UITextElement(
      this.ctx,
      0,
      0,
      btn_w,
      btn_h,
      {
        localization_key: "OK",
        font_size: LayoutScaler.textSizeFromDesign( 60 ),
        font_weight: 900,
        text_color: ColorScheme.white,
        text_style: TextStyleScheme.geologica,
        text_align: MyTextAlign.Center,
        vertical_align: MyTextVerticalAlign.Center,
        auto_wrap: false,
        scale_to_width: true,
        ...TextStyleScheme.buttonShadow(),
        outline_color: ColorScheme.more_lives_buy_outline,
        outline_width: LayoutScaler.textBorderSizeFromDesign( 8 ),
        outline_offset_y: LayoutScaler.yFromDesign( 2 ),
      }
    ), true );

    button.setOnClick( () => this.close() );
    this.addChild( button );
  }
}
